import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  padding: 2rem;
  margin-bottom: 1rem;
  border-radius: 0.4rem;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    h2 {
      font-weight: 500;
      font-size: 2.3rem;
      color: #1349a4;
    }
  }

  strong {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 1rem;
  }

  div {
    margin-top: 1rem;
  }

  p {
    color: rgba(0, 0, 0, 0.7);
  }
`;
